import { Button, Modal } from "antd";
import { t } from "i18next";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { onError } from "src/common/onError";

import { MdmUploadStore } from "../MdmUploadStore";
import { UploaderDragger } from "../UploaderDragger";
import * as styles from "./UploaderModal.module.less";

type PropsUploaderModal = {
  store: MdmUploadStore;
};

export const UploaderModal: React.FC<PropsUploaderModal> = observer(
  ({ store }) => {
    const { modalOpen, isImage } = store;
    const handlePaste = (e: ClipboardEvent) => {
      store.onPaste(e).catch(onError);
    };
    React.useEffect(() => {
      if (modalOpen) document.addEventListener("paste", handlePaste);
      return () => {
        document.removeEventListener("paste", handlePaste);
      };
    }, [modalOpen]);
    const close = () => store.setModalOpen(false);
    return (
      <Modal
        height="80vh"
        open={modalOpen}
        onCancel={close}
        className={styles.imageUploadModal}
        title={isImage ? t("Image modification") : t("File modification")}
        closable={false}
        maskClosable={false}
        centered
        footer={
          <div className={styles.modalFooter}>
            <Button
              className={styles.finishButton}
              type="primary"
              onClick={close}
            >
              {t("Finish")}
            </Button>
          </div>
        }
      >
        <UploaderDragger store={store} />
      </Modal>
    );
  },
);
